import { FC } from "react";
import { useI18n } from "../../hooks/useTranslations";
import { useCarDriversApi } from "../../http/carDrivers/api";
import { formatDateNumeric } from "../../types/utils";
import HistoryDialog from "../ui/HistoryDialog";

import { getTypesOfUse } from "../../http/cars/types";
import VersionDialog from "../ui/VersionDialog";

type CarDriverHistoryDialogProps = {
  itemToShowVersionsId: string;
  itemVersionToShowVersions: number;
  onClose: () => void;
};

const CarDriverHistoryDialog: FC<CarDriverHistoryDialogProps> = ({
  itemToShowVersionsId,
  itemVersionToShowVersions,
  onClose,
}) => {
  const i18n = useI18n();
  const carDriversApi = useCarDriversApi();

  const typesOfUse = getTypesOfUse(i18n.t);

  return (
    <HistoryDialog
      title={i18n.t.carDrivers.versions}
      lastVersion={itemVersionToShowVersions}
      entityId={itemToShowVersionsId}
      getEntityVersionHook={carDriversApi.getAdminCarDriverVersion}
      getHistory={carDriversApi.getAdminCarDriverHistory}
      onClose={onClose}
      renderForm={(headers, dataVersion) => (
        <VersionDialog.Table headers={headers}>
          {(dataVersion.current?.car?.id ?? null) !== (dataVersion.next.car?.id ?? null) && (
            <tr>
              <VersionDialog.Field
                label={i18n.t.cars.singular}
                value={
                  dataVersion.current?.car?.currentPlateNumber || dataVersion.current?.car?.vehicleIdentificationNumber
                }
                edited={dataVersion.next?.car?.currentPlateNumber || dataVersion.next?.car?.vehicleIdentificationNumber}
              />
            </tr>
          )}
          {(dataVersion.current?.driver?.id ?? null) !== (dataVersion.next.driver?.id ?? null) && (
            <tr>
              <VersionDialog.Field
                label={i18n.t.drivers.singular}
                value={dataVersion.current?.driver?.fullName}
                edited={dataVersion.next?.driver?.fullName}
              />
            </tr>
          )}
          {dataVersion.current?.startDate != dataVersion.next.startDate && (
            <tr>
              <VersionDialog.Field
                label={i18n.t.common.startDate}
                value={dataVersion.current && formatDateNumeric(dataVersion.current?.startDate, i18n.language)}
                edited={formatDateNumeric(dataVersion.next?.startDate, i18n.language)}
              />
            </tr>
          )}
          {(!dataVersion.current || dataVersion?.current?.endDate !== dataVersion.next.endDate) && (
            <tr>
              <VersionDialog.Field
                label={i18n.t.common.endDate}
                value={dataVersion.current.endDate && formatDateNumeric(dataVersion.current?.endDate, i18n.language)}
                edited={dataVersion.next?.endDate && formatDateNumeric(dataVersion.next?.endDate, i18n.language)}
              />
            </tr>
          )}
          {dataVersion.current?.typeOfUse != dataVersion.next.typeOfUse && (
            <tr>
              <VersionDialog.Field
                label={i18n.t.common.typeOfUse}
                value={typesOfUse.find((x) => x.value == dataVersion.current?.typeOfUse)?.label}
                edited={typesOfUse.find((x) => x.value == dataVersion.next?.typeOfUse)?.label}
              />
            </tr>
          )}
        </VersionDialog.Table>
      )}
    />
  );
};

export default CarDriverHistoryDialog;
